// 自定义指令 v-store 获取下拉选择框的店铺列表
const shop = {
  shop: {
    // 当被绑定的元素插入到 DOM 中
    inserted: function(el, binding, vnode) {
      const _this = vnode.context
      let resultObj = _this
      if (el.dataset.key && typeof (el.dataset.key) === 'string') {
        const keyList = el.dataset.key.split('.')
        keyList.forEach(item => {
          resultObj = resultObj[item]
        })
      } else {
        _this.$message({
          type: 'error',
          message: '请输入data-key'
        })
      }

      if (resultObj instanceof Array && resultObj.length > 0) {
        return
      }

      resultObj.push({
        label: '全部',
        value: ''
      })

      _this.$api.getStoreList({
        merchantCode: _this.$store.getters.merchantCode || '',
        auditStatus: 2,
        state: true,
        pageNo: 1,
        pageSize: 999
      }).then(res => {
        if (res && res.data && res.data.list instanceof Array) {
          const storeList = res.data.list
          for (let i = 0, len = storeList.length; i < len; i++) {
            resultObj.push({
              label: storeList[i].name,
              value: storeList[i].code
            })
          }
        }
      })
    }
  }
}

// 自定义指令 v-fare 获取下拉选择框的运费模版列表
const fare = {
  fare: {
    // 当被绑定的元素插入到 DOM 中
    inserted: function(el, binding, vnode) {
      const _this = vnode.context
      let resultObj = _this
      if (el.dataset.key && typeof (el.dataset.key) === 'string') {
        const keyList = el.dataset.key.split('.')
        keyList.forEach(item => {
          resultObj = resultObj[item]
        })
      } else {
        _this.$message({
          type: 'error',
          message: '请输入data-key'
        })
      }

      _this.$api.getTemplateSelect(_this.$store.getters.merchantCode).then(res => {
        if (res && res.data && res.data instanceof Array) {
          const templeteList = res.data
          for (let i = 0, len = templeteList.length; i < len; i++) {
            resultObj.push({
              label: templeteList[i].templateName,
              value: templeteList[i].templateCode
            })
          }
        }
      })
    }
  }
}

// 自定义指令 v-logistics 获取下拉选择框的快递公司
const logistics = {
  logistics: {
    // 当被绑定的元素插入到 DOM 中
    inserted: function(el, binding, vnode) {
      const _this = vnode.context
      let resultObj = _this
      if (el.dataset.key && typeof (el.dataset.key) === 'string') {
        const keyList = el.dataset.key.split('.')
        keyList.forEach(item => {
          resultObj = resultObj[item]
        })
      } else {
        _this.$message({
          type: 'error',
          message: '请输入data-key'
        })
      }

      _this.$api.getLogisticsCompany({
        dicCode: 'LOGISTICS_COMPANY',
        pageNo: 1,
        pageSize: 100
      }).then(res => {
        if (res && res.data && res.data.list instanceof Array) {
          const companyList = res.data.list
          for (let i = 0, len = companyList.length; i < len; i++) {
            resultObj.push({
              label: companyList[i].dicName,
              value: `${companyList[i].dicName}:${companyList[i].dicValue}`
            })
          }
        }
      })
    }
  }
}

// 自定义指令 v-company 获取下拉选择框的权限下的公司
const company = {
  company: {
    inserted: function(el, binding, vnode) {
      const _this = vnode.context
      let resultObj = _this
      if (el.dataset.key && typeof (el.dataset.key) === 'string') {
        const keyList = el.dataset.key.split('.')
        keyList.forEach(item => {
          resultObj = resultObj[item]
        })
      } else {
        _this.$message({
          type: 'error',
          message: '请输入data-key'
        })
      }
      _this.$api.getPermissionCompany({
        appendMain: !_this.$store?.state.user.companyCode && binding.arg != 'nohead'
      }).then(res => {
        const companyList = res.data || []
        resultObj.splice(0, resultObj.length)
        for (let i = 0, len = companyList.length; i < len; i++) {
          resultObj.push({
            label: companyList[i].companyName,
            value: `${companyList[i].companyCode}`
          })
        }
      })
    }
  }
}

const loadmore = {
  bind(el, binding, vnode) {
    const selector = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    let awaitPromise = null
    selector.addEventListener('scroll', function() {
      const scrollPosition = this.scrollHeight - Math.ceil(this.scrollTop) <= this.clientHeight
      if (scrollPosition && this.scrollTop !== 0 && !awaitPromise) {
        // 接收一个promise
        awaitPromise = binding.value(selector)
        awaitPromise.then(() => {
          awaitPromise = null
        }).catch(() => {
          awaitPromise = null
        })
      }
    })
  }
}

const permission = {
  inserted(el, binding, vnode) {
    const buttons = vnode?.componentInstance?.$route?.meta?.buttons ?? []
    const pureValue = `${binding?.value}`.replace(/\'/g, '')
    const btnActions = buttons.map(btn => btn.name)
    if (!btnActions.includes(pureValue)) {
      if (binding.arg) {
        // 对于没有权限但需要显示的元素
        const $props = vnode?.componentInstance || {}
        $props[binding.arg] = true
      } else {
        el.style.display = 'none'
      }
    } else {
      el.style.display = ''
    }
  },
  componentUpdated(el, binding, vnode) {
    permission.inserted(el, binding, vnode)
  }
}

// 自定义指令 v-page-permission 获取绑定的路由是否有权限
const pagePermission = {
  inserted(el, binding, vnode) {
    const pureValue = `${binding?.value}`.replace(/\'/g, '')
    const permissionRoute = vnode?.componentInstance?.$store?.getters?.permission_routes
    if (permissionRoute) {
      const routerList = []
      const getRouterList = function(permissionList, str = '') {
        permissionList?.forEach((permission) => {
          let current = str
          if (permission.path.match(/^\//)) {
            current = permission.path
          } else {
            current = str + ('/' + permission.path)
          }
          if (permission.children && permission.children.length) {
            getRouterList(permission.children, current)
          } else {
            routerList.push(current)
          }
        })
      }
      getRouterList(permissionRoute)
      const index = routerList.indexOf(pureValue)
      el.style.display = index !== -1 ? '' : 'none'
    }
  }
}

export { shop, fare, logistics, company, loadmore, permission, pagePermission }
